var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('history-detail-component',{attrs:{"history-type":'itemHistory',"historyKey":_vm.historyKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }